import Table from "../../Table/Table";
import classes from "../../Table/Table.module.css";
import { useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import authContext from "../../../../AuthContext/authContext";
import appActions from "../../../../ReduxStore/appDataSlice";
import { useEffect } from "react";
import { toast } from "react-toastify";
import Home from "../../Common/Home/Home";
import ConfirmModal from "../../Common/ConfirmModal/ConfirmModal";
import AssignPassesModal from "./AssignPassesModal";
const base_url = process.env.REACT_APP_BASE_URL;
const LocationWrapper = () => {
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  console.log(activeCompany,"activeCompany");
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(authContext);
  const userType = ctx.userData.user_type;
  const token = ctx.token;
  const [employeeDirectory, setShowEmployeeDirectory] = useState(false);
  const [isLoading, setIsloading] = useState(true);
  const [locationToDelete, setLocationToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [assignPassesModal, setAssignPassesModal] = useState({
    isOpen: false,
    locationId: null,
    locationName: '',
    currentPasses: 0,
    maxPasses: 1000,
    totalPassesAllocatedToTheCompany: 0,
    isLoading: false,
  });
  const [ppoEntries, setPpoEntries] = useState({});

  const handleEdit = (id) => {
    dispatch(appActions.setActiveEditLocationId(id));
    localStorage.setItem("activeEditLocationId", id);
    dispatch(appActions.setActiveEditType("Location"));
    localStorage.setItem("activeEditType", "Location");
    navigate("/editLocation");
  };

  const handleDelete = (id) => {
    setIsloading(true);
    let reqObj = {
      method: "DELETE",
      url: `${base_url}/company/location/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios(reqObj)
      .then((res) => {
        setIsloading(false);
        toast.success("Location deleted successfully.");
      })
      .catch((err) => {
        console.log(err);
        setIsloading(false);
        toast.error("Failed to delete Location.");
      });
  };

  useEffect(() => {
    // setIsloading(true);
    fetchCompanyDetails();
    // fetchCompanyDetails is now defined above and called from useEffect
  }, []);

  const fetchCompanyDetails = async () => {
    setIsloading(true);
    try {
      const reqObj = {
        method: "GET",
        url: `${base_url}/company/details/${activeCompany._id}`,
        headers: {
          "Content-Type": "application/javascript",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios(reqObj);
      setShowEmployeeDirectory(response.data.employeeDirectory);
      
      // Optimized PPO data handling
      const ppoData = response.data.ppoData;
      if (Array.isArray(ppoData)) {
        // Find first active PPO or use empty object
        let activePpo = {};
        for (let i = 0; i < ppoData.length; i++) {
          if (ppoData[i]?.isActive === true) {
            activePpo = ppoData[i];
            break; // Exit loop as soon as we find the first active PPO
          }
        }
        setPpoEntries(activePpo);
      } else {
        setPpoEntries({});
      }
    } catch (err) {
      console.error("Error fetching company details:", err);
    } finally {
      setIsloading(false);
    }
  };
  console.log(ppoEntries,"ppoEntries")


  const columns = [
    {
      name: "S. No.",
      cell: (row, index) => index + 1,
    },
    {
      name: "Manager Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => row.location,
      sortable: true,
    },
    ppoEntries?.ppoPassCount > 0 && {
      name: "Passes",
      selector: (row) => {
        return `${parseInt(row.passes-row.availablePasses) || 0}/${row.passes || 0}`;
      },
      sortable: true,
      conditionalCellStyles: [
        {
          when: row => row.passes && row.availablePasses,
          style: {
            fontWeight: 'bold',
            color: '#333'
          }
        }
      ]
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          <div className={classes.icons} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <div className={classes.iconWrapper}>
              <img
                className={classes.actionIcon}
                src={require("../../../../assets/img/admin-images/edit_thin.png")}
                onClick={() => handleEdit(row._id)}
                alt="Edit"
              />
            </div>
            {/*<div className={classes.iconWrapper}>
              <img
                className={classes.actionIcon}
                data-bs-toggle="modal"
                data-bs-target="#exampleModal"
                src={require("../../../../assets/img/admin-images/delete.png")}
                onClick={() => setLocationToDelete({ id: row._id, location: row.location })}
                alt="Delete"
              />
            </div>*/}
            {userType === "Company Manager" && ppoEntries.ppoPassCount > 0 && (
              <div className={classes.iconWrapper}>
                <button 
                  onClick={() => {
                    setAssignPassesModal({
                      isOpen: true,
                      locationId: row._id,
                      locationName: row.location,
                      currentPasses: row.passes - row.availablePasses || 0,
                      maxPasses: row.passes,
                      totalPassesAllocatedToTheCompany: parseInt(ppoEntries.availablePassCount) || 0,
                      isLoading: false
                    });
                  }}
                  title="Manage Pass"
                  className="bg-white text-blue-600 border border-blue-600 hover:bg-blue-50 font-medium py-1 px-1 rounded-md text-sm transition-colors duration-200"
                >
                  Manage Pass
                </button>
              </div>
            )}
          </div>
        </>
      ),
    },
  ];

  let showAddNew = true;
  let showCsvExport = false;
  let showDownload = false;
  let showExport = false;
  let showLocation = false;
  let showSms = true;
  let showFirstHr = false;
  let showSecondHr = true;
  let showActions = true;
  let showVisitor = true;
  let ppoEnable = false;
  

  if (userType === "Company Manager") {
    showAddNew = true;
    showCsvExport = false;
    showDownload = false;
    showExport = false;
    showLocation = false;
    showSms = false;
    showFirstHr = false;
    showSecondHr = false;
    showActions = false;
    showVisitor = false;
    ppoEnable = true;
  }

  const options = {
    // title: activeCompany.name,
    title: "Location",
    showCsvExport: showCsvExport,
    showDownload: showDownload,
    showExport: showExport,
    showLocation: showLocation,
    showSms: showSms,
    showAddNew: showAddNew,
    showFirstHr: showFirstHr,
    showSecondHr: showSecondHr,
    showActions: showActions,
    type: "Location",
    columns: columns,
    apiUrl: `${base_url}/company/location/list`,
    companyId: activeCompany?._id,
    showVisitor: showVisitor,
    employeeDirectorySwitch: employeeDirectory,
    ppoEnable: ppoEnable,
    ppoEntries: ppoEntries? ppoEntries : {},
  };
  // console.log(options,"options");
  console.log(isLoading,"isLoading");
  
  return (
    <>
      <ConfirmModal
        handleDelete={handleDelete}
        id={locationToDelete?.id}
        msg={`Are you sure you want to delete ${locationToDelete?.location}?`}
      />
      <Home propComponent={<Table options={options} isLoading={isLoading} />} />
    
      
      <AssignPassesModal
        key={assignPassesModal.locationId || 'modal'}
        isOpen={assignPassesModal.isOpen}
        onClose={() => setAssignPassesModal({
          isOpen: false,
          locationId: null,
          locationName: '',
          currentPasses: 0,
          maxPasses: 1000,
          totalPassesAllocatedToTheCompany: 0,
          isLoading: false,
          payload: { passes: 0, action: '' }
        })}
        onAssignPasses={async (payload) => {
          try {
            setAssignPassesModal(prev => ({ ...prev, isLoading: true }));

            const response = await axios.post(
              `${base_url}/company/assign-passes/${activeCompany._id}`,
              { passes:payload.passes, locationId: assignPassesModal.locationId, action: payload.action },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${ctx.token}`
                }
              }
            );
            toast.success('Pass balance updated successfully');
            setAssignPassesModal({
              isOpen: false,
              locationId: null,
              locationName: '',
              currentPasses: 0,
              maxPasses: 1000,
              totalPassesAllocatedToTheCompany: 0,
              isLoading: false,
              payload: { passes: 0, action: '' }
            })
            fetchCompanyDetails();
          } catch (error) {
            console.error('Error assigning passes:', error);
            toast.error(error.response?.data?.message || 'Failed to assign passes');
          } finally {
            setAssignPassesModal(prev => ({ ...prev, isLoading: false }));
          }
        }}
        locationName={assignPassesModal.locationName}
        currentPasses={assignPassesModal.currentPasses}
        maxPasses={assignPassesModal.maxPasses}
        totalPassesAllocatedToTheCompany={assignPassesModal.totalPassesAllocatedToTheCompany}
        isLoading={assignPassesModal.isLoading}
      />
 
    </>
  );
};

export default LocationWrapper;
